import KeyboardDoubleArrowRight from "@mui/icons-material/KeyboardDoubleArrowRight";
import IconButton from "@mui/material/IconButton";
import { CustomLink } from "core/components/CustomLink";
import { pickHighlight, renderHighlight } from "core/components/HighlightText";
import { MyLinksIcon } from "features/MyLinks/components/MyLinksIcon";
import { getMyLinksHref } from "features/MyLinks/utils";
import type { SearchResult, SearchResultLibrary } from "../defs";
import { SearchItemTemplate } from "./SearchItemTemplate";

export function searchResultIsLibrary(
  input: SearchResult
): input is SearchResultLibrary {
  return input.itemType === "DmsLibrary";
}

export function SearchItemLibrary({
  dynamicData,
  title,
  blurb,
  isFavorited,
  highlights,
}: SearchResultLibrary) {
  return (
    <SearchItemTemplate
      data-testid="search-item-dms-library"
      secondaryAction={
        <IconButton
          LinkComponent={CustomLink}
          href={getMyLinksHref("DmsLibrary", dynamicData.path)}
        >
          <KeyboardDoubleArrowRight color="primary" />
        </IconButton>
      }
      AvatarIcon={<MyLinksIcon itemType="DmsLibrary" />}
      title={renderHighlight(title, pickHighlight(highlights, "String1"))}
      middleSlot={renderHighlight(blurb, pickHighlight(highlights, "String5"))}
      isFavorited={isFavorited}
    />
  );
}
